import store from '@/store'

/**
 * 权限指令 v-permission
 *
 * 用法：
 *   <el-button v-permission="'device:control'">控制设备</el-button>
 *   <el-button v-permission="['device:control', 'device:update']">操作</el-button>
 */
export default {
  inserted(el, binding) {
    const { value } = binding
    const permissions = store.state.user.permissions

    if (!value) return

    // 超管放行
    if (permissions.includes('*')) return

    const required = Array.isArray(value) ? value : [value]
    const hasPermission = required.some(perm => permissions.includes(perm))

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
